import { useTranslation } from '@/contexts/LanguageContext';
import SEO from '@/components/SEO';

export default function PrivacyPage() {
  const { t } = useTranslation('privacy');

  const sections = t('sections');
  const sectionsList = Array.isArray(sections) ? sections : [];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="privacy-page">
      <SEO title="Politique de confidentialité" description="Découvrez comment DestockPro protège vos données personnelles et respecte le RGPD sur sa marketplace de déstockage professionnel." path="/politique-confidentialite" />
      <section className="mb-10">
        <h1 className="font-heading text-3xl font-bold text-neutral-900 dark:text-white mb-2">{t('title')}</h1>
        <p className="text-sm text-neutral-400 dark:text-neutral-500">{t('lastUpdate')}</p>
      </section>

      <section className="space-y-8" data-testid="privacy-content">
        {sectionsList.map((section, i) => (
          <div key={i}>
            <h2 className="font-heading text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">{section.title}</h2>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed">{section.text}</p>
            {section.list && (
              <ul className="mt-2 ml-5 list-disc space-y-1">
                {section.list.map((item, j) => (
                  <li key={j} className="text-sm text-neutral-600 dark:text-neutral-400">{item}</li>
                ))}
              </ul>
            )}
            {section.textAfter && (
              <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-2 leading-relaxed">{section.textAfter}</p>
            )}
          </div>
        ))}
      </section>
    </div>
  );
}
